import request from '../request';

//提交购物车
export const reqAddData = (data) => request({ url:'/admin/orders/submitCart', method:'post', data });
